import React from 'react';
import ManageSubscription from './ManageSubscription';
import './BillingPage.css';

const BillingPage = () => (
  <div className="appBillingPage">
    <ManageSubscription />
  </div>
);

export default BillingPage;
